// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'arrow-above-row-right';

export const Component = () => (
  <path d='m14.177 2-.67.719 4.358 3.927H0v.958h17.816l-4.31 3.88.67.718 5.7-5.076-5.7-5.124V2ZM24.52 22.306H0v-8.812h24.521v8.812Zm-7.855-7.854v6.896h6.897v-6.896h-6.897Zm-7.854 0v6.896h6.897v-6.896H8.813Zm-7.854 0v6.896h6.897v-6.896H.958Z' />
);

export const viewBox = '0 0 25 25';
